import cn from 'classnames';
import Button from '../components/common/Button';

const SORT_DIRECTION_ASC = 'asc';
const SORT_DIRECTION_DESC = 'desc';

export const SortDirection = {
  ASC: SORT_DIRECTION_ASC,
  DESC: SORT_DIRECTION_DESC,
};

export const SortKey = {
  CANCELLED_AT: 'cancelledAt',
  ORDER_CREATED_AT: 'orderCreatedAt',
  RETURNED_AT: 'returnedAt',
  MODEL: 'model',
  ORDERS_COUNT: 'totalOrderCount',
};

export const getDynamicColumn = (variants) => {
  const allOptions = new Set();

  if (variants) {
    variants.forEach((item) => {
      Object.keys(item.options).forEach((option) => {
        allOptions.add(option);
      });
    });
  }

  return Array.from(allOptions);
};

export const getMax = (variants) => {
  return variants.reduce(
    (max, p) => (p.available_inventory > max ? p.available_inventory : max),
    variants[0].available_inventory,
  );
};

export const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => {
  const buttons = options.map((option) => (
    <Button
      key={option.page}
      text={option.text}
      color={currSizePerPage === option.text ? null : 'white'}
      onClick={() => onSizePerPageChange(option.page)}
    />
  ));

  return (
    <div className="btn-group" role="group">
      {buttons}
    </div>
  );
};

export const paginationTotalRenderer = (from, to, size) => {
  return (
    <div className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </div>
  );
};

export const sortCaret = (direction) => {
  const classes = ['ic-sort', direction === 'asc' ? 'asc' : 'desc'];

  if (direction) {
    classes.push('selected');
  }

  return <span className={cn(classes)} />;
};
